var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "pagination w-100"
  }, [_c('b-card', {
    staticClass: "w-100"
  }, [_c('div', {
    staticClass: "w-100 d-flex justify-content-end"
  }, [_vm.hasStatistical ? _c('span', {
    staticClass: "pagination__statistical mr-1"
  }, [_vm._v("Page " + _vm._s(_vm.currentPage) + " of " + _vm._s(Math.round(_vm.rows / _vm.perPage) + 1) + " (" + _vm._s(_vm.rows) + " items)")]) : _vm._e(), _c('b-pagination', {
    ref: "pagination",
    attrs: {
      "total-rows": _vm.rows,
      "per-page": _vm.perPage,
      "pills": "",
      "last-number": ""
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }